import { loStageDepositConfigs, applicantStageDepositConfigs } from "./depositaccounts/businessdda";


export const texasBankApplicationStages = [
    loStageDepositConfigs,
    applicantStageDepositConfigs
]